// PM Phase 16 — Lightweight analytics tracker
// Fires beacon-style events to /api/analytics/track. Non-blocking.

const API_URL = process.env.REACT_APP_BACKEND_URL;

const getOrCreateSessionId = () => {
  if (typeof window === 'undefined') return '';
  let sid = sessionStorage.getItem('aadhyaa_session_id');
  if (!sid) {
    sid = `s_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem('aadhyaa_session_id', sid);
  }
  return sid;
};

export const trackEvent = (eventType, properties = {}) => {
  if (typeof window === 'undefined') return;
  try {
    const token = localStorage.getItem('prana_token');
    const body = {
      event_type: eventType,
      page_url: window.location.pathname,
      properties,
      session_id: getOrCreateSessionId(),
    };
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;
    // Fire & forget — don't await
    fetch(`${API_URL}/api/analytics/track`, {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* silent */
  }
};

export const trackPageView = (path) => trackEvent('page_view', { path: path || window.location.pathname });
